// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"arrow_shadow__3F75U","image":"arrow_image__2IUic","upside":"arrow_upside__3TfsB"};